import { render, staticRenderFns } from "./VoltageGauge.vue?vue&type=template&id=3812a3ae"
import script from "./VoltageGauge.vue?vue&type=script&lang=js"
export * from "./VoltageGauge.vue?vue&type=script&lang=js"
import style0 from "./VoltageGauge.vue?vue&type=style&index=0&id=3812a3ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports